// extracted by mini-css-extract-plugin
module.exports = {"root":"TimeZone-module__root__3_cC8"};